import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import styled from "styled-components";
import { motion } from "framer-motion";
import {
  BackgroundContainer,
  Content,
  MainContainer,
  MainContent,
} from "../../../styles/styles";
import { SideBar } from "../../../components/nav/SideBar";
import GlowEffect from "../../../components/background/GlowEffect";
import { StartSection } from "./styles";
import { useNavigationStore } from "../../../store/navigationStore";
import { useUploadStore } from "../../../store/uploadStore";
import FileUploader from "../../../features/upload/FileUploader";
import UploadIntroContainer from "../../../features/upload/IntroContainer";
// Notification is now handled globally in App via NotificationWatcher

const BackgroundWrapper = styled.div`
  position: absolute;
  inset: 0;
  overflow: hidden;
`;

const getIntroProps = (projectId: string) => {
  switch (projectId) {
    case "audion_vu":
      return {
        headline: "음성이해",
        description: {
          text: "오디오를 올리면 자동으로, ",
          highlight: "텍스트로 변환",
          text2: "합니다.\n지금 파일을 업로드하거나 유튜브 링크를 입력해보세요.",
        },
      };
    case "audion_vh":
      return {
        headline: "보이스 하이라이트",
        description: {
          text: "",
          highlight: "음성의 흐름과 감정의 변화",
          text2: "를 한눈에 확인하세요.\n오디오 파일이나 유튜브 링크를 올려주세요.",
        },
      };
    // case "audion_sg":
    //   return {
    //     tag: "자막 생성",
    //     headline: "Subtitle Generation",
    //     description: {
    //       text: "AI가 음성을 분석해 ",
    //       highlight: "정확한 자막을 자동 생성",
    //       text2: "합니다.\n파일을 업로드하거나 유튜브 링크를 입력해보세요.",
    //     },
    //   };
    default:
      throw new Error(`Unknown projectId ID: ${projectId}`);
  }
};

const FileUploadPage: React.FC = () => {
  const { projectId } = useParams<{ projectId: string }>();
  const { isCollapsed } = useNavigationStore();
  const resetState = useUploadStore((state) => state.resetState);

  useEffect(() => {
    resetState();
    return () => resetState();
  }, [resetState]);

  // Notification handling moved to global watcher

  const introProps = projectId ? getIntroProps(projectId) : undefined;
  if (!projectId || !introProps) return null;

  return (
    <BackgroundContainer>
      <BackgroundWrapper>
        <GlowEffect />
      </BackgroundWrapper>

      <MainContainer>
        <Content $isCollapsed={isCollapsed}>
          <SideBar />
          <MainContent style={{ justifyContent: "center" }}>
            <StartSection>
              <motion.div
                key={`${projectId}-intro`}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, ease: "easeOut" }}
              >
                <UploadIntroContainer {...introProps} />
              </motion.div>

              <motion.div
                key={`${projectId}-uploader`}
                initial={{ opacity: 0, y: 40 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{
                  duration: 0.8,
                  ease: "easeOut",
                  delay: 0.1,
                }}
              >
                <FileUploader
                  projectId={projectId}
                />
              </motion.div>
            </StartSection>
          </MainContent>
        </Content>
      </MainContainer>
    </BackgroundContainer>
  );
};

export default FileUploadPage;
